import { render, staticRenderFns } from "./OverviewSidebar.vue?vue&type=template&id=5f34b7e2&scoped=true"
import script from "./OverviewSidebar.vue?vue&type=script&lang=js"
export * from "./OverviewSidebar.vue?vue&type=script&lang=js"
import style0 from "./OverviewSidebar.vue?vue&type=style&index=0&id=5f34b7e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f34b7e2",
  null
  
)

export default component.exports